export const postalCodeFormat = (postalRequest) => {
    return postalRequest.replace(/\s/g, '').substr(0,6);
}

export const postalCodeFormatWithSpace = (postal) => {
    return postalCodeFormat(postal).replace(/(.{3})/g, '$1 ');
}
